// AccidentsList/index.js
import { connect } from 'react-redux';
import AccidentsList from '../../components/AccidentsList';
import { domainType } from '../../constants';

import {
  fetchAllAccidentsForBranchDispatch,
  openEditAccidentDialogDispatch,
  accidentEditClickDispatch,
  showDeleteOrActivateAccidentDialogStatChanged,
  fetchExistingAttachmentsForTheAccidentDispatch
} from '../../actions';

function mapStateToProps(state, ownProps) {
  return {
    branchId: state.branch.branch.item && state.branch.branch.item.id,
    accidents: state.accidents.accidentsByBranch.items
  };
}

function mapDispatchToProps(dispatch, ownProps) {
  return {
    fetchAllAccidentsForBranch: (branchId) => {
      dispatch(fetchAllAccidentsForBranchDispatch(branchId));
    },
    handleAccidentEditClick: (accident, loggedInUserId) => {
      dispatch(openEditAccidentDialogDispatch(true));
      dispatch(accidentEditClickDispatch(accident));
      dispatch(
        fetchExistingAttachmentsForTheAccidentDispatch(
          domainType.ACCIDENT,
          accident.id,
          loggedInUserId
        )
      );
    },
    openDeleteOrDeactiveAccidentDialog: (open, accident, status) => {
      dispatch(
        showDeleteOrActivateAccidentDialogStatChanged(open, accident, status)
      );
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AccidentsList);
